"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var style = {
  "button": "binary_font_button-module__button___XPTSC"
};
class BinaryFontButton extends _react.default.PureComponent {
  render() {
    const {
      onInitial,
      onClick,
      initial,
      next
    } = this.props;
    const character = onInitial ? initial : next;
    return /*#__PURE__*/_react.default.createElement("i", {
      onClick: onClick,
      className: `icon-${character} ${style.button}`,
      "aria-hidden": "true"
    });
  }
  static defaultProps = {
    onInitial: true,
    onClick: () => {}
  };
}
exports.default = BinaryFontButton;